import { useCanManageCommitteesBool } from "@/hooks/useCapabilities";
import useCapabilities from "@/hooks/useCapabilities";

export const GROUP_EMAIL_PAGE_PATH = "/people/membership-services/group-email" as const;

/** Pure gate: HQ staff with `manageCommittees` (MS Admin, Technology Staff, Global Admin). */
export function canAccessGroupEmailPage(manageCommittees: boolean): boolean {
  return manageCommittees;
}

export function useCanAccessGroupEmailPage() {
  const { loaded } = useCapabilities();
  const manageCommittees = useCanManageCommitteesBool();

  return { loaded, canAccess: loaded && canAccessGroupEmailPage(manageCommittees) };
}
